export let locations = {
  clientId: '2b501946-9ba4-4fcb-a790-e4672b8c8c5c',
  locationDetails: [
    {
      locationId: '861f46cf-0796-4d34-beb0-d78b0602b642',
      locationName: 'Wall',
    },
    {
      locationId: '861f46cf-0796-4d34-beb0-d78b0602b643',
      locationName: 'Wall_2',
    },
  ],
};
